import * as R from 'ramda';
import Api from '../../../common/services/api';
import { ECourseTypes } from '../definitions';
import { LEARNING_GENERATE_OUTLINE } from './index';

const whitelist = [
  'topic',
  'fileId',
  'industry',
  'length',
  'includeQuiz',
  'language',
  'toneOfVoice',
  'learningGoal',
  'type'
];

export default (values) => async (dispatch, getState) => {
  const { organisation: { selected } } = getState();

  const payload = R.pick(whitelist, values);

  const { data: response } = await Api.post(
    `/v2/organisations/${selected.id}/courses/generate_outline`,
    payload
  );

  const outline = response.outline || response;

  const transformedSettings = {
    ...R.pick(whitelist, values),
    courseType: values.type,
  };

  return dispatch({
    type: LEARNING_GENERATE_OUTLINE,
    item: outline,
    settings: transformedSettings,
  });
};
